module.exports = __webpack_public_path__ + "static/media/zhariff-blue.788e0904.png";